import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CommonModal from '../../common/Modal';
import './index.scss';

const PrescriptionAlertModal = ({ closeDialogHandler = () => {} }) => {
  const { t } = useTranslation();
  useEffect(() => {
    setTimeout(() => {
      document.body.style.overflow = 'hidden';
    }, 10);
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <div className="prescriptionAlertWrapper">
      <CommonModal
        closeDialogHandler={closeDialogHandler}
        closeButtonIMG="icon-close-white.svg"
        isInitialFocusToClose={true}
      >
        <div className="prescriptionAlertContent">
          <div className="bellIcon desktop-only" />
          <div className="description">
            <p className="setTitle">{t('Prescription alert')}:</p>
            <div className="combinationWrap">
              <div className="bellIcon mobile-only" />
              <p>{t('Price unavailable')}</p>
            </div>
          </div>
        </div>
        <p className="noteContainer">
          {t('Please adjust the prescription details')}
        </p>
      </CommonModal>
    </div>
  );
};

export default PrescriptionAlertModal;
